/**
 * Environment Configuration
 * 
 * This module provides a centralized way to access environment variables.
 * It prioritizes actual environment variables over the public/config.js fallback.
 */

const getConfig = () => {
  // 1. First, check actual environment variables from Vite (import.meta.env)
  // These are injected by the platform and should take precedence.
  const envVars = {
    NCB_INSTANCE: import.meta.env.VITE_NCB_INSTANCE || import.meta.env.NCB_INSTANCE,
    NCB_AUTH_API: import.meta.env.VITE_NCB_AUTH_API || import.meta.env.NCB_AUTH_API,
    NCB_DATA_API: import.meta.env.VITE_NCB_DATA_API || import.meta.env.NCB_DATA_API,
    NCB_SECRET_KEY: import.meta.env.VITE_NCB_SECRET_KEY || import.meta.env.NCB_SECRET_KEY,
  };

  // 2. Check if runtime config exists (from public/config.js)
  const runtimeConfig = (typeof window !== 'undefined' && window.ENV_CONFIG) ? window.ENV_CONFIG : {};

  // 3. Merge them, prioritizing real values over placeholders
  const isPlaceholder = (val) => !val || val.includes('YOUR_') || val === 'NCB_SECRET_KEY';

  const merged = {
    NCB_INSTANCE: !isPlaceholder(envVars.NCB_INSTANCE) ? envVars.NCB_INSTANCE : (runtimeConfig.NCB_INSTANCE || ''),
    NCB_AUTH_API: !isPlaceholder(envVars.NCB_AUTH_API) ? envVars.NCB_AUTH_API : (runtimeConfig.NCB_AUTH_API || ''),
    NCB_DATA_API: !isPlaceholder(envVars.NCB_DATA_API) ? envVars.NCB_DATA_API : (runtimeConfig.NCB_DATA_API || ''),
    NCB_SECRET_KEY: !isPlaceholder(envVars.NCB_SECRET_KEY) ? envVars.NCB_SECRET_KEY : (runtimeConfig.NCB_SECRET_KEY || ''),
  };

  // Log configuration status (without exposing full secret)
  const maskedKey = merged.NCB_SECRET_KEY ? `${merged.NCB_SECRET_KEY.substring(0, 4)}...` : 'not set';
  console.log('[ENV] Configuration loaded:', {
    instance: merged.NCB_INSTANCE || 'missing',
    authUrl: merged.NCB_AUTH_API || 'missing',
    hasSecret: !!merged.NCB_SECRET_KEY,
    keyPrefix: maskedKey
  });

  return merged;
};

export const ENV = getConfig();

// Validation check
if (!ENV.NCB_INSTANCE || !ENV.NCB_AUTH_API || !ENV.NCB_SECRET_KEY) {
  console.warn('⚠️ Environment configuration is incomplete. Please check your environment variables.');
}